import { HEADER_AGENT_CODE_REFERENCE, HHMT_THEME } from 'constants';

export const agentCode =
  HEADER_AGENT_CODE_REFERENCE[
    process.env.REACT_APP_APP_NAME || HHMT_THEME
  ].toLowerCase();

export const mockAbortSignalERRCANCELED = (timeoutMs) => {
  const abortController = new AbortController();
  setTimeout(() => abortController.abort(), timeoutMs || 0);
  return abortController.signal;
};

export const mockAPITimeout = (axios, timeout) => {
  const TIMEOUT_DEFAULT = 60000;
  axios.defaults.timeout = 100;
  const timer = setTimeout(() => {
    axios.defaults.timeout = timeout || TIMEOUT_DEFAULT;
    clearTimeout(timer);
  }, 100);
};

export const mockHTTPCode = (mockStatus) => {
  const mockStatusMessage = {
    400: {
      message: 'Request failed with status code 400',
      resMessage: 'Something went wrong',
    },
    500: {
      message: 'Request failed with status code 400',
      resMessage: 'Internal server error',
    },
  };

  return Promise.reject({
    isAxiosError: true,
    message: mockStatusMessage[mockStatus].message,
    response: {
      status: mockStatus,
      data: {
        message: mockStatusMessage[mockStatus].resMessage,
      },
    },
  });
};
